import React from 'react'
import { useIntl } from 'react-intl'

import {
  Flex,
  SpacingVertical,
  SPACING_40,
  Title,
  TITLE_VARIANT_MODAL,
  Text,
  TEXT_VARIANT_LIGHT
} from 'mailup-web-components'

const Header = () => {
  const intl = useIntl()

  return (
    <>
      <Flex width='100%' flexDirection='column' alignItems='center'>
        <Title
          variant={TITLE_VARIANT_MODAL}
          data-mu-test='select-recipient-header-title'
        >
          {intl.formatMessage({
            id: 'Load.PreviewViewer.SelectARecipient'
          })}
        </Title>
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({
            id: 'Load.PreviewViewer.SelectARecipientDescr'
          })}
        </Text>
        <SpacingVertical variant={SPACING_40} />
      </Flex>
    </>
  )
}

export default Header
